// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".donor-detail-view .data-label[data-v-41aefbe7]{color:#434959!important;text-transform:uppercase!important;font-size:.75rem!important;font-weight:600!important}.donor-detail-view .data-value[data-v-41aefbe7]{font-size:1.2rem!important;color:#484a50!important}.donor-detail-view .v-data-table[data-v-41aefbe7]  .v-data-table-header{background-color:#f5f6f8!important;text-transform:uppercase!important}", ""]);
// Exports
module.exports = exports;
